<template>
  <v-container>
    <!-- <v-layout row>
      
    </v-layout> -->
    <v-layout row>

      <v-select
      v-model="mandatesToSearch"
      :items="mandates"
      item-text="name"
      label="Choose your mandates"
      chips
      clearable
      solo
      dense
      multiple
      hint="Pick multiple mandates"
      persistent-hint
      @click:clear="clearTableData()"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :selected="data.selected"
            close
            label
            @input="remove(data.item)"
          >
          <v-flex xs2>
            <v-avatar size="25px">
              <img :src="'https://firebasestorage.googleapis.com/v0/b/scf-custom.appspot.com/o/flags%2F' + data.item.flag + '?alt=media'" />
            </v-avatar>
          </v-flex>
          <v-flex class='ml-1'>
            {{ data.item.name }}
          </v-flex>
          </v-chip>
        </template>

        <template slot="item" slot-scope="data">
          <v-list-tile-avatar>
            <img :src="'https://firebasestorage.googleapis.com/v0/b/scf-custom.appspot.com/o/flags%2F' + data.item.flag + '?alt=media'" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-select>

      <v-btn 
        large
        v-if="mandatesToSearch.length>0" 
        color="red darken-4 white--text"
        @click="addTableData()"
      >Create Table <v-icon right dark>view_list</v-icon></v-btn>
    </v-layout>
    
    <v-layout row>

      <download-excel
        :data="tableData"
        :fields="csvHeaders"
        name="custom_scf.csv"
        type="csv"
        >

        <v-btn class="ml-0" color="info" >Download Excel {{tableData.length}}<v-icon right dark>play_for_work</v-icon></v-btn>

      </download-excel>
      <!-- <download-csv
        :data="tableData"
        :labels="csvHeaders"
        name="custom_scf.csv"
        >

        <v-btn class="ml-0" color="info">Download Excel <v-icon right dark>play_for_work</v-icon></v-btn>

      </download-csv> -->
      
      

      <v-spacer></v-spacer>

      <v-btn 
        class="mx-0" 
        color="primary"
        :href="'https://firebasestorage.googleapis.com/v0/b/scf-custom.appspot.com/o/sheets%2F' + masterSheetFileName + '?alt=media'"
      >
        Download Master Spreadsheet<v-icon right dark>play_for_work</v-icon>
      </v-btn>
    </v-layout>

    <v-data-table
      v-if="mandatesToSearch.length > 0"
      :headers="headers"
      :items="tableData"
      class="elevation-1"
      no-data-text="Press Create Table"
      :rows-per-page-items="[25,50,100]"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item.scf_control }}</td>
        <td class="text-xs-right">{{ props.item.scf_desc }}</td> -->
        <td v-for="header in headers" :key="header.id">
          {{ props.item[header.value] }}
        </td>
      </template>
    </v-data-table>    
  
  </v-container>
</template>

<script>

import { db, storageRef } from '../firebaseConfig.js'
import { debug, debuglog } from 'util'

export default {
  data() {
    return {
      mandQuery: db.collection('mandates2'),
      tableQuery: db.collection('scf_num'),
      mandates: [],
      manData: [],
      mandatesToSearch: [],
      headers: [],
      tableData: [],
      csvHeaders: {},
      csvHeadersAry: null,
      masterSheetFileName: null,
      // counter: 0,
      // btnReady: 'Downloading..',
    }
  },
  created() {
    this.mandQuery.orderBy('index').get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        // console.log(doc.id)
        this.mandates.push({
          name: doc.id,
          flag: doc.data().flag_id
        })
        // console.log(doc.id, doc.data().flag_id)
      })
    }),
    db.collection('storage').doc('masterSheet').get()
    .then(sheetFile => {
      let file = sheetFile.data()
      let fileName = file.docName
      this.masterSheetFileName = encodeURIComponent(fileName)
      
    })
  },
  methods: {
    addTableData() {
      // this.counter = 0
      this.tableData = []
      this.headers = [
          { text: 'SCF Domain', value: 'scf_domain' },
          { text: 'SCF #', value: 'scf_num' },
          { text: 'SCF Control', value: 'scf_control' },
          { text: 'Secure Controls Framework Description ', value: 'scf_desc' },
          { text: 'Methods To Comply With SCF Controls', value: 'methods_comply' },
          
        ]
      // loop through each mandate name
      this.manData.forEach( man => {
        // man[0] is ie. US HIPPA
        this.headers.push( { text: man[0], value: man[0] } )
        // loop through each mandates scf_num
        man[1].forEach(scf => {
          if (scf === 'flag_id') { return }

          this.tableQuery.doc(scf).get()
          .then(doc => {
            let scfData = doc.data()
            // run for loop of table data if it has the scf then add to that nested object if not create new row
            if (this.tableData.length > 0) {
              let duplicate = false
              this.tableData.forEach(row => {
                if ( row['scf_num'] === scf ) {
                  // console.log('duplicate :', scf)
                  duplicate = true
                  row[man[0]] = scfData[man[0]]
                  // this.counter++
                  // debugger
                  // this.btnReady = 'Downloading...'
                }
              })
              if (!duplicate) {
                this.tableData.push( 
                  {
                    scf_control: scfData['SCF Control'],
                    scf_desc: scfData['Secure Controls Framework (SCF) Control Description'].replace(/"/g, "").replace(/[▪\t+]/g, ''),
                    [man[0]]: scfData[man[0]],
                    scf_num: scfData['SCF #'],
                    scf_domain: scfData['SCF Domain'],
                    methods_comply: scfData['Methods To Comply With SCF Controls'],
                  } 
                )
                duplicate = false
                // this.counter++
                // this.btnReady = 'Downloading...'
              }
            } else { //need to start table with one push - some data
              this.tableData.push( 
                {
                  scf_control: scfData['SCF Control'],
                  scf_desc: scfData['Secure Controls Framework (SCF) Control Description'],
                  [man[0]]: scfData[man[0]],
                  scf_num: scfData['SCF #'],
                  scf_domain: scfData['SCF Domain'],
                  methods_comply: scfData['Methods To Comply With SCF Controls'],
                } 
              )
              // this.counter++
              // this.btnReady = 'Downloading...'
            }

          })
          .catch(error => {
            console.log('Table data search: ', error)
            // console.log(scf)
          })
        })
      })
      // this.btnReady = 'Download Excel'
    },
    clearTableData() {
      this.tableData = []
      // this.counter = 0
    },
    remove(item) {
      this.mandatesToSearch.splice(this.mandatesToSearch.indexOf(item), 1)
      this.mandatesToSearch = [...this.mandatesToSearch]
    }
  },
  watch: {
    headers: function() {
      this.headers.forEach(h => {
        // return { [h['text']]: h['value'] }
        this.csvHeaders[h['text']] = h['value']
      })
      this.headers.forEach(h => {
        this.csvHeadersAry.push( [ h['text'] = h['value'] ] )
      })
    },
    tableData: function() {
      console.log('buffering')
    },
    // counter: function() {
    //   // if (this.counter == this.tableData.length ) {
    //   //   console.log('theyre equal')
    //   //   this.btnReady = "Download Excel"
    //   // } else {
    //   //   this.btnReady = "Downloading..."
    //   // }
    // },
    mandatesToSearch: function() {
      this.manData = []
      let scfControls = []
      // trying to clear tableData when data is done downloading but sometime a person clears before the promise is done
      // show loading while addToTable() by counting a count
      this.mandatesToSearch.forEach(m => {
        this.mandQuery.doc(m).get()
        .then(doc => {          
            scfControls = doc.data()
            this.manData.push( [doc.id, Object.keys(scfControls)] )
        })
        .catch(error => {
          console.log('Mandates search: ', error)
        })
      })
    }
  }
}
</script>

<style>
  .v-avatar img, .v-avatar .v-icon, .v-avatar .v-image {
    border-radius: initial;
    width: auto;
    max-height: 100px;
  }

  .v-avatar {
    width: auto !important;
  }
  /* .v-list__tile__title {
    text-align: right;
  } */
  .v-list__tile__avatar {
    min-width: 200px;
  }
</style>
